import { Box, Paper, Typography } from "@mui/material";
import type { ReactNode } from "react";

export function StatCard({
  icon,
  label,
  value,
}: {
  icon: ReactNode;
  label: string;
  value: ReactNode;
}) {
  return (
    <Paper sx={{ p: 2.5, height: "100%", borderLeft: "4px solid #3D7A76" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2,
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(61,122,118,0.12)",
            color: "primary.main",
          }}
        >
          {icon}
        </Box>
        <Typography color="text.secondary" variant="body2">
          {label}
        </Typography>
      </Box>
      <Typography variant="h4">{value}</Typography>
    </Paper>
  );
}
